export default "__VITE_ASSET__95e8dc39__"